module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('b-navbar', {
    attrs: {
      "toggleable": "",
      "variant": "faded"
    }
  }, [_c('b-nav-toggle', {
    attrs: {
      "target": "nav_collapse"
    }
  }), _vm._v(" "), _c('b-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/favicon.ico",
      "width": "30",
      "height": "30",
      "classs": "d-inline-block align-top",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("Koonys Quizzes "), _c('span', {
    attrs: {
      "id": "beta"
    }
  }, [_vm._v("Beta")])])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "nav_collapse"
    }
  }, [_c('b-nav', {
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Startseite")])], 1), _vm._v(" "), _c('b-nav', {
    staticClass: "ml-auto",
    attrs: {
      "is-nav-bar": ""
    }
  }, [(_vm.user.isAnonymous) ? _c('b-nav-item', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")]) : _c('b-nav-item-dropdown', {
    staticClass: "img-profile",
    attrs: {
      "right": true,
      "caret": false
    }
  }, [_c('template', {
    slot: "text"
  }, [_c('img', {
    staticClass: "hidden-sm-down",
    attrs: {
      "src": _vm.user.photoURL,
      "title": _vm.user.displayName
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-md-up"
  }, [_vm._v("Account")])]), _vm._v(" "), _c('b-dropdown-header', [_vm._v(_vm._s(_vm.user.displayName))]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/user/quizzes"
    }
  }, [_c('i', {
    staticClass: "fa fa-user fa-fw"
  }), _vm._v(" Deine Quizzes")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out fa-fw"
  }), _vm._v(" Signout")])], 2)], 1)], 1)], 1), _vm._v(" "), (_vm.user.uid !== null) ? _c('router-view') : _c('div'), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "footer"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row mb-3"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col text-right"
  }, [_c('b-button', {
    attrs: {
      "variant": "link",
      "size": "sm",
      "onclick": "_urq.push(['Feedback_Open'])"
    }
  }, [_vm._v("Feedback")])], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('hr')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('small', [_c('a', {
    staticClass: "text-muted",
    attrs: {
      "href": "http://www.koonys.de",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-copyright fa-fw"
  }), _vm._v(" Koonys Schule")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-559a1148"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 710
// module chunks = 1